import { useQuery } from 'react-query';
import getOrderReport from './admin-main';

export default function useOrderReport() {
    const { data, refetch } = useQuery(['admin-main'], getOrderReport);

    return { data, refetch };
}
